import { useMemo } from 'react';
import { AssetClassDTO } from '../ManageExcessCashModal.meta';

export const useExcessCashModalForm = (allocationList: AssetClassDTO[]) => {
  const marketAssumptions = useMemo(() => {
    return allocationList.map(item => ({ ...item, y: item.y * 100 }));
  }, [allocationList]);

  return { marketAssumptions };
};
